/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.space.defs'

type $nsid = typeof $nsid

export { $nsid }

/** A signed commit over the current state of a permissioned repo. */
type SignedCommit = {
  $type?: 'com.atproto.space.defs#signedCommit'

  /**
   * Commit format version, currently 1. Corresponds to the version in the ctx protocol tag (atproto-space-v1).
   */
  ver: number

  /**
   * sha256 digest of the LtHash state (32 bytes).
   */
  hash: Uint8Array

  /**
   * Per-signature input keying material (32 random bytes)
   */
  ikm: Uint8Array

  /**
   * Signature over ctx (space, author DID, rev, ikm) by the user's atproto signing key. Does not cover the repo hash.
   */
  sig: Uint8Array

  /**
   * HMAC-SHA256 over hash, keyed by HKDF-SHA256(ikm, info=ctx). Binds the repo hash to this commit's context.
   */
  mac: Uint8Array

  /**
   * Commit revision (TID), also bound into ctx.
   */
  rev: l.TidString
}

export type { SignedCommit }

/** A signed commit over the current state of a permissioned repo. */
const signedCommit = /*#__PURE__*/ l.typedObject<SignedCommit>(
  $nsid,
  'signedCommit',
  /*#__PURE__*/ l.object({
    ver: /*#__PURE__*/ l.integer(),
    hash: /*#__PURE__*/ l.bytes(),
    ikm: /*#__PURE__*/ l.bytes(),
    sig: /*#__PURE__*/ l.bytes(),
    mac: /*#__PURE__*/ l.bytes(),
    rev: /*#__PURE__*/ l.string({ format: 'tid' }),
  }),
)

export { signedCommit }
